import CustomModal from "../../../../components/Modal/CustomModal";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";
import useReactGASend from "../../../../hooks/useReactGASend";

const ListItem = ({
  label,
  isHot,
  value,
  handleOnClick,
  color,
  index,
  onClick,
}) => {
  return (
    <li
      role="button"
      className={`flex items-center font-medium leading-loose border-2 cursor-pointer h-14 rounded-custom pl-2 pr-7 ${
        isHot ? " border-purple-700" : `px-7 border-${color}`
      }`}
      onClick={() => {
        handleOnClick(value, isHot, label);
        onClick();
      }}
    >
      <p className="truncate text-neutral-600">
        <span
          className={`relative top-[-1px] mr-2.5 font-montserrat w-9 h-6 inline-flex items-center justify-center text-center text-[11px] font-bold rounded-[13px] border ${
            isHot
              ? " border-purple-700 bg-purple-500 text-white"
              : `border-${color} bg-${color} text-black text-base`
          }`}
        >
          {isHot ? "HOT" : index + 1}
        </span>
        {label}
      </p>
    </li>
  );
};

const FAQModal = ({
  realtiemList,
  questionList,
  search,
  handleOnClick,
  isOpen,
  onRequestClose,
}) => {
  const { color } = useSelectBrand();

  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: title,
      body: body,
    });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="디지털 상담 FAQ"
      btnClose
      modalBottom
    >
      <div className="flex w-full flex-col mb-5">
        <h3 className="mb-1 text-xl font-bold">이슈 & 자주하는 문의</h3>
        <p className="text-sm font-medium text-neutral-400">
          실시간 이슈와 자주 묻는 질문입니다.
        </p>
      </div>
      <div className="flex w-full flex-col overflow-y-auto max-h-[300px]">
        <ul className="flex flex-col gap-1">
          {realtiemList?.map((list) => (
            <ListItem
              key={list.order}
              label={list.question}
              value={list.value}
              isHot
              search={search}
              handleOnClick={handleOnClick}
              onClick={() =>
                trackButtonClick(`이슈_${list.question}`, {
                  data_btn_nm: `이슈_${list.question}`,
                })
              }
            />
          ))}
          {questionList?.map((list, index) => (
            <ListItem
              key={list.order}
              label={list.question}
              value={list.value}
              index={index}
              search={search}
              handleOnClick={handleOnClick}
              onClick={() =>
                trackButtonClick(`이슈_${list.question}`, {
                  data_btn_nm: `이슈_${list.question}`,
                })
              }
              color={color}
            />
          ))}
        </ul>
      </div>
    </CustomModal>
  );
};

export default FAQModal;
